<script>
  export default {
    name: 'VGridformSlider',
    props: {
      label: {
        type: String,
        default: ''
      },
      hint: {
        type: String,
        default: ''
      }
    },
    data() {
      return {}
    },

    computed: {

    },
    watch: {

    },

    mounted() {
      console.log('this', this)
      console.log('this.$attrs', this.$attrs)
    },

    methods: {

    }
  }
</script>

<template>
  <div class="v-gridform-slider v-input">
    <div class="v-gridform-slider__control v-input__control">
      <div class="v-gridform-slider__slot v-input__slot">
        <label class="v-label" v-text="label"></label>
        <div class="v-gridform-slider__main v-slider v-slider--horizontal">
          <input readonly tabindex="-1" autocomplete="off">
          <div class="v-gridform-slider__track v-slider__track-container">
            <VBtn absolute dark fab small color="accent" class="v-gridform-slider__track-minus">
              <VIcon>mdi-minus</VIcon>
            </VBtn>
            <div class="v-gridform-slider__track-background v-slider__track-background"></div>
            <VBtn absolute dark fab small color="accent" class="v-gridform-slider__track-plus">
              <VIcon>mdi-plus</VIcon>
            </VBtn>
          </div>
          <div class="v-gridform-slider__ticks"></div>
        </div>
      </div>
      <div class="v-gridform-slider__messages v-messages">
        <div class="v-gridform-slider__messages-wrapper">
          <div class="v-messages__message" v-text="hint"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .v-input {
    display: flex;
    flex: 1 1 auto;
    align-items: flex-start;
    max-width: 100%;
    font-size: 16px;
    text-align: left;
    letter-spacing: normal;
  }
  .v-input__slot {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    min-height: inherit;
    margin-bottom: 8px;
    color: inherit;
    transition: .3s cubic-bezier(.25,.8,.5,1);
  }
  .v-input__control {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    flex-wrap: wrap;
    width: 100%;
    min-width: 0;
    height: auto;
  }
  .v-label {
    min-height: 8px;
    font-size: 16px;
    line-height: 1;
    transition: .3s cubic-bezier(.25,.8,.5,1);
  }
  .v-slider {
    position: relative;
    display: flex;
    flex: 1;
    align-items: center;
    cursor: default;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  .v-slider--horizontal {
    min-height: 32px;
    margin-right: 8px;
    margin-left: 8px;
  }
  .v-slider__track-container {
    position: absolute;
    border-radius: 0;
    .v-gridform-slider__track-minus {
      position: absolute;
      top: calc(50% - 20px);
      left: 0;
    }
    .v-gridform-slider__track-plus {
      position: absolute;
      top: calc(50% - 20px);
      right: 0;
    }
  }
  .v-slider--horizontal .v-slider__track-container {
    top: 50%;
    left: 0;
    width: 100%;
    height: 2px;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
  }
  .v-slider__thumb-container,
  .v-slider__track-background,
  .v-slider__track-fill {
    position: absolute;
    transition: .3s cubic-bezier(.25,.8,.5,1);
  }
  .v-slider__track-background {
    width: 100%;
    background-color: #63a6b8 !important;
    border-color: #63a6b8 !important;
  }
  .v-messages {
    position: relative;
    flex: 1 1 auto;
    min-width: 1px;
    min-height: 14px;
    font-size: 12px;
  }
  .v-messages__message {
    line-height: normal;
    word-break: break-word;
    overflow-wrap: break-word;
    word-wrap: break-word;
    -webkit-hyphens: auto;
    -ms-hyphens: auto;
    hyphens: auto;
  }
</style>
